import * as moment from 'moment';
import { IEventFilter, ICalendarState, IOption } from '../classes/calendar';
import { IEvent } from '../custom/classes/event';
import filter from '../components/filters/filter';
import { upsertEventFilter } from '../redux-state/actions/calendar.actions';
import { Store, Dispatch } from 'redux';
import { getMonthElement, scrollToMonth, removeLoader } from './scroll-to-month';


export function AddFilterToQuery(eventFilters: Array<IEventFilter>): void {
    const serialized = serializeProps(eventFilters);
    if (serialized.length > 0) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + encodeURI(serialized);
        window.history.pushState({ path: newurl }, '', newurl);
    }
}

export function GetFilterFromQuery(search: string, filterOptions: Array<IOption>,
    filterToGet: string, lastLoadedMonth: moment.Moment, selectFiltersFunction:(filter, shouldUpdateQuery)=> any, goToMonthFunction: (toMonth) => any): void {
    // Remove hash added for Month scrolling
    if (search.substr(1).length > 0) {
        let queries = decodeURI(search.substr(1)).split('&');

        var matchedQuery = queries.filter(q => q.indexOf(filterToGet) == 0)[0];

        if (matchedQuery) {
            let value = matchedQuery.split('=')[1].replace(/-/g, ' ');

            selectFiltersFunction(value, false);

            var matchedFilter = filterOptions.filter(o => o.value === value)[0];

            if (matchedFilter) {
                const firstOccuranceDate = matchedFilter.firstOccurance;

                // If a month is 
                if (firstOccuranceDate) {
                    const toMonth = moment(firstOccuranceDate);

                    // Only change months if it's in the future.
                    if (toMonth.isAfter(lastLoadedMonth)) {
                        goToMonthFunction(toMonth);
                        var scrollInterval = setInterval(() => {
                            const monthElement = getMonthElement(toMonth);

                            if (monthElement) {
                                removeLoader();
                                if (scrollToMonth(toMonth)) {
                                    clearInterval(scrollInterval);
                                }
                            }
                        }, 500);
                    } else {
                        // If the month has already loaded, apply filter and remove the loader.
                        // We need a timeout because even though the data is cached, a Promise object is created.
                        //setTimeout(() => removeLoader(), 500);
                        var scrollInterval = setInterval(() => {
                            const monthElement = getMonthElement(toMonth);

                            if (monthElement) {
                                removeLoader();
                                if (scrollToMonth(toMonth)) {
                                    clearInterval(scrollInterval);
                                }
                            }
                        }, 500);
                    }

                } else {
                    // If the month has already loaded, apply filter and remove the loader.
                    // We need a timeout because even though the data is cached, a Promise object is created.
                    setTimeout(() => removeLoader(), 500);
                }
            }
        }

    }
}

function serializeProps(eventFilter: Array<IEventFilter>): string {
    if (eventFilter.length < 1)
        return "";

    return "?" + eventFilter.map(filter => filter.key + "=" + filter.selectedValue).join("&");
}


export function generateEventFilter(propertyToFilter: string, selectedValue: string) {
    return (event: IEvent) => {
        const propertyValue = event[propertyToFilter];
        // If it's an array, check if the value exists inside
        if (propertyValue.constructor === Array) {
            return (propertyValue as any[]).some(item => item === selectedValue);
        } else {
            return event[propertyToFilter] === selectedValue
        }
    }
}
